import React from 'react'
import { DcButton, PixelFactoryContext, PixelTable } from 'pixel-base'
import {
  approveExpense,
  getExpenses,
  payExpense,
  refuseExpense,
  submitExpense,
} from 'utils/api-routes-accounts'
import FinancePageShell from '../../components/FinancePageShell'
import FinanceStatusBadge from '../../components/FinanceStatusBadge'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { Expense } from '../../types/finance'
import formatFinanceDate from '../../utils/formatFinanceDate'

const Expenses = () => {
  const pixelFactory = React.useContext(PixelFactoryContext) as any
  const expenses = useFinanceObservable<Expense[]>(() => getExpenses())

  const runAction = (request, successMessage: string) => {
    request.subscribe({
      next: () => {
        pixelFactory?.showSuccess?.(successMessage)
        expenses.refresh()
      },
      error: () => pixelFactory?.showFailure?.('Expense action failed'),
    })
  }

  return (
    <FinancePageShell title="Expenses" isLoading={expenses.loading}>
      <PixelTable
        columns={[
          { name: 'ID', selector: (row) => row.id },
          { name: 'Description', selector: (row) => row.description || '--' },
          {
            name: 'Posting Date',
            selector: (row) =>
              formatFinanceDate(row.posting_date || row.document_date),
          },
          { name: 'Amount', selector: (row) => row.amount_total || '--' },
          {
            name: 'Status',
            selector: (row) => <FinanceStatusBadge status={row.status} />,
          },
          { name: 'Move', selector: (row) => row.posted_move_id || '--' },
          {
            name: 'Actions',
            selector: (row) => (
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <DcButton
                  size="sm"
                  variant="outline-primary"
                  onClick={() =>
                    runAction(submitExpense(row.id), 'Expense submitted')
                  }
                >
                  Submit
                </DcButton>
                <DcButton
                  size="sm"
                  variant="outline-success"
                  onClick={() =>
                    runAction(approveExpense(row.id), 'Expense approved')
                  }
                >
                  Approve
                </DcButton>
                <DcButton
                  size="sm"
                  variant="outline-danger"
                  onClick={() =>
                    runAction(refuseExpense(row.id), 'Expense refused')
                  }
                >
                  Refuse
                </DcButton>
                <DcButton
                  size="sm"
                  variant="outline-warning"
                  onClick={() =>
                    runAction(
                      payExpense(row.id, {
                        idempotency_key: `expense-pay-${row.id}`,
                      }),
                      'Expense paid',
                    )
                  }
                >
                  Pay
                </DcButton>
              </div>
            ),
          },
        ]}
        data={expenses.data || []}
        searchable
        pagination
      />
    </FinancePageShell>
  )
}

export default Expenses
